<app-add-category [viewTitle]="title" [isParentCategory]="loadParentId"></app-add-category>